module.exports = __webpack_public_path__ + "img/icon_market.1027b756.0854c8cb.svg";